<template>
    <b-modal id="modal-contact-form" size="lg" header-bg-variant="secondary" header-text-variant="light" body-bg-variant="light" title="Get in touch" hide-footer scrollable>
        <contact-form />
    </b-modal>
</template>
<script>
import ContactForm from '@/components/about/ContactForm';

export default {
    name: 'modal-contact-form',
    components: {
        ContactForm,
    },
};
</script>
<style>
#modal-contact-form h5 {
    font-size: 25px;
}
#modal-contact-form .modal-body {
    padding-top: 30px;
    padding-bottom: 60px;
}
#modal-contact-form .close {
    outline: none;
    font-size: 30px;
}
</style>
